<style scoped>
.grey--text.v-card.v-card--hover.v-sheet.theme--light {
  overflow: hidden;
}

.v-image {
  -webkit-animation-name: order-finished;
  -webkit-animation-duration: 8s;
  animation-name: order-finished;
  animation-duration: 8s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  position: relative;
}

@-webkit-keyframes order-finished {
  0% {
    left: -700px;
    top: 0px;
  }

  25% {
    left: 100px;
    top: 0px;
  }

  50% {
    left: 700px;
    top: 0px;
  }

  75% {
    left: 700px;
    top: 200px;
  }

  100% {
    left: -700px;
    top: 200px;
  }
}

@keyframes order-finished {
  0% {
    left: -700px;
    top: 0px;
  }

  25% {
    left: 100px;
    top: 0px;
  }

  50% {
    left: 700px;
    top: 0px;
  }

  75% {
    left: 700px;
    top: 200px;
  }

  100% {
    left: -700px;
    top: 200px;
  }
}
</style>

<template>
  <v-container fluid mt-5>
    <v-layout column wrap mt-5 align-center>
      <v-flex xs8 class="text-xs-center" mt-5>
        <v-flex align-content-center mt-5>
          <v-card :hover="true" class="grey--text">
            <v-flex>
              <v-card-title>
                <h5>
                  <v-icon large color="yellow">check</v-icon>
                  Thank you. Your order has been received.
                </h5>
              </v-card-title>
              <v-flex xs12 class="text-xs-left" pl-4 pr-4>
                <blockquote>
                  You will get a separate email with an order confirmation.
                  <br />
                  Please be aware that it might take some time until this order
                  appears in your order status overview.
                </blockquote>
              </v-flex>
              <v-img
                :src="require('@/assets/img/send-order-car.png')"
                contain
                max-height="80"
              ></v-img>
              <v-card-actions class="pa-3">
                <v-btn block ripple class="white--text primary" to="/">
                  <v-icon>home</v-icon>
                  &nbsp;Home
                </v-btn>
                <v-btn block ripple @click="userSignOut">
                  <v-icon>lock</v-icon>
                  &nbsp;Logout
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: mapActions("auth", ["userSignOut"])
};
</script>
